// YERİ: src/app/domains/site/sections/column-blocks.ts
// Kolon içi hafif bloklar — tam-genişlik "section" değil, kolonlara yerleşen sade
// içerik öğeleri: metin, görsel, buton. Tema CSS vars ile renklenir.

import { Component, computed, input, inject } from '@angular/core';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

// ── Metin bloğu ───────────────────────────────────────────────────────────────
@Component({
  selector: 'sec-text-block',
  standalone: true,
  template: `
    <div class="px-6 py-8" [class]="alignClass()">
      @if (heading()) {
        <h3 class="font-[family-name:var(--site-head-font)] text-2xl font-bold tracking-tight text-neutral-900 dark:text-white">{{ heading() }}</h3>
      }
      @if (body()) {
        <div class="mt-3 leading-relaxed text-neutral-600 dark:text-neutral-300 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5 [&_a]:underline" [innerHTML]="body()"></div>
      }
    </div>
  `,
})
export class TextBlock {
  protected kabuk = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected heading = computed(() => cfg(this.config(), 'heading', this.kabuk.t('fb.baslik')));
  protected body = computed(() => cfg(this.config(), 'body', this.kabuk.t('fb.buBirMetinBlogudur')));
  protected align = computed(() => cfg<string>(this.config(), 'align', 'left'));
  protected alignClass = computed(() => this.align() === 'center' ? 'text-center' : this.align() === 'right' ? 'text-right' : 'text-left');
}

// ── Görsel bloğu ──────────────────────────────────────────────────────────────
@Component({
  selector: 'sec-image-block',
  standalone: true,
  template: `
    <div class="px-6 py-8">
      @if (url()) {
        <img [src]="url()" [alt]="alt()" class="w-full object-cover" [class]="roundedClass()" />
      } @else {
        <div class="flex aspect-video w-full items-center justify-center rounded-xl bg-neutral-100 text-sm text-neutral-400 dark:bg-neutral-800">{{ kabuk.t('cb.addImage') }}</div>
      }
    </div>
  `,
})
export class ImageBlock {
  /** Kabuk metni — bu bilesende `text` adi CMS icerigi icin kullanildi. */
  protected kabuk = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected url = computed(() => cfg<string>(this.config(), 'url', ''));
  protected alt = computed(() => cfg(this.config(), 'alt', ''));
  protected roundedClass = computed(() => cfg(this.config(), 'rounded', true) ? 'rounded-2xl' : '');
}

// ── Buton bloğu ───────────────────────────────────────────────────────────────
@Component({
  selector: 'sec-button-block',
  standalone: true,
  template: `
    <div class="px-6 py-8" [class]="alignClass()">
      <a [href]="url()" [target]="newTab() ? '_blank' : '_self'" [attr.rel]="newTab() ? 'noopener' : null"
         class="ws-btn inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold transition hover:opacity-90"
         [class.text-white]="variant() !== 'outline'"
         [style.background-color]="variant() === 'outline' ? 'transparent' : 'var(--site-accent)'"
         [style.color]="variant() === 'outline' ? 'var(--site-primary)' : null"
         [style.border]="variant() === 'outline' ? '1px solid var(--site-primary)' : null">
        {{ text() }}
      </a>
    </div>
  `,
})
export class ButtonBlock {
  config = input<SiteConfig>({});
  protected text = computed(() => cfg(this.config(), 'text', 'Buton'));
  protected url = computed(() => cfg(this.config(), 'url', '#'));
  protected variant = computed(() => cfg<string>(this.config(), 'variant', 'solid'));
  protected align = computed(() => cfg<string>(this.config(), 'align', 'left'));
  protected alignClass = computed(() => this.align() === 'center' ? 'text-center' : this.align() === 'right' ? 'text-right' : 'text-left');
  protected newTab = computed(() => ['true', 'evet', '1'].includes(String(cfg(this.config(), 'newTab', '')).toLowerCase()));
}
